import { createContext, useContext, ReactNode } from 'react';
import { useAssetState } from '../hooks/asset/useAssetState';

// Define the shape of the context data
export type AssetContextType = ReturnType<typeof useAssetState>;

// Create the context with a default value of null
export const AssetContext = createContext<AssetContextType | null>(null);

export const AssetProvider: React.FC<{ children: ReactNode }> = ({ children }) => {
  const assetState = useAssetState();

  return (
    <AssetContext.Provider value={assetState}>
      {children}
    </AssetContext.Provider>
  )
};

// Custom hook for consuming the context
export const useAsset = (): AssetContextType => {
  const context = useContext(AssetContext);
  if (!context) {
    throw new Error('useAsset must be used within a AssetProvider');
  }
  return context;
};